import React, { useEffect, useRef } from "react";
import {
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Box,
  InputGroup,
  InputRightElement,
  Flex,
  Text,
} from "@chakra-ui/react";
import ErrorMessage from "./ErrorMessage";

const ValidatedInputWithCounter = ({
  name,
  value = "",
  onChange,
  type = "text",
  placeholder = "",
  label,
  isRequired,
  isDisabled = false,
  valueInNumber = false,
  styles = {},
  error,
  rightElement,
  maxLength,
  isTextarea = false,
}) => {
  const inputRef = useRef(null);

  const handleChange = (e) => {
    const val = e.target.value;

    if (maxLength && val.length > maxLength) return;

    if (valueInNumber) {
      onChange({
        target: {
          name,
          value: Number(val),
        },
      });
    } else {
      onChange(e);
    }
  };

  useEffect(() => {
    const input = inputRef.current;
    if (!input) return;

    const preventScroll = (e) => e.preventDefault();
    input.addEventListener("wheel", preventScroll);

    return () => {
      input.removeEventListener("wheel", preventScroll);
    };
  }, []);

  const currentLength = value?.length || 0;
  const remaining = maxLength ? maxLength - currentLength : null;

  const InputComponent = isTextarea ? Textarea : Input;

  return (
    <FormControl mb={4}>
      <FormLabel htmlFor={name}>
        {label}
        {isRequired && (
          <Box as="span" color="red.500" ml={1}>
            *
          </Box>
        )}
      </FormLabel>

      <InputGroup>
        <InputComponent
          id={name}
          name={name}
          type={type}
          placeholder={placeholder}
          onChange={handleChange}
          isDisabled={isDisabled}
          value={value}
          ref={inputRef}
          maxLength={maxLength}
          {...styles}
        />

        {rightElement && (
          <InputRightElement width="4rem">
            <Box textAlign="left" w="100%">
              {rightElement}
            </Box>
          </InputRightElement>
        )}
      </InputGroup>

      {maxLength && (
        <Flex justify="space-between" mt={1}>
          <Text fontSize="xs" color="gray.500">
            {currentLength} / {maxLength}
          </Text>
          <Text
            fontSize="xs"
            color={remaining < 0 ? "red.500" : "gray.500"}
          >
            {remaining} characters left
          </Text>
        </Flex>
      )}

      <ErrorMessage error={error} />
    </FormControl>
  );
};

export default ValidatedInputWithCounter;
